import React, { Component, createRef } from "react";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";
import pkg from "../../package.json";
import configMap from "../data/config";
import materialsMap from "../data/materials";

import "./NavNitrum.scss";
import { ReactComponent as IconDownload } from "../assets/images/download.svg";
import { ReactComponent as IconFacebook } from "../assets/images/facebook.svg";
import { ReactComponent as IconTwitter } from "../assets/images/twitter.svg";
import { ReactComponent as IconEmail } from "../assets/images/email-alt.svg";
import { ReactComponent as IconCopy } from "../assets/images/copy.svg";

function mapState(state) {
  return {
    nitrumOpen: state.nav.nitrumOpen,
    config: state.config,
    configCode: state.config._code,
    region: state.config._region,
  };
}

class NavNitrum extends Component {
  constructor(props) {
    super();
    this.pdfMode = "html"; // html|form
    this.shareUrlUsesHash = true;
    this.state = {
      showCopiedFeedback: false
    };
    this.copyInput = createRef();

    const url = new URL(window.location.toString());
    this.baseUrl = url.origin + (pkg.homepage || "");
  }

  getShareUrl(target) {
    const { t } = this.props;

    let shareUrl = this.shareUrlUsesHash 
      ? `${this.baseUrl}/index.html#/share/${this.props.configCode}`
      : `${this.baseUrl}/share/${this.props.configCode}`;
    shareUrl = encodeURIComponent(shareUrl);

    let url;

    if (target === "facebook") {
      url = `https://www.facebook.com/sharer/sharer.php?u=${shareUrl}`;

    } else if  (target === "twitter") {
      const text = encodeURIComponent(t("share_tweet_text"));
      const rel = "SunriseMedical";
      url = `https://twitter.com/intent/tweet?text=${text}&url=${shareUrl}&related=${rel}`;

    } else if  (target === "email") {
      const subject = encodeURIComponent(t("share_email_subject"));
      const body = encodeURIComponent(t("share_email_body") + " ") + shareUrl;
      url = `mailto:?subject=${subject}&body=${body}`;
    }

    return url;
  };

  copyCode() {
    const input = this.copyInput.current;

    if (input !== null) {
      input.select();
      input.setSelectionRange(0, 99999); // For mobile devices
      document.execCommand("copy");
      window.getSelection().removeAllRanges();
      
      this.setState({ showCopiedFeedback: true });
      setTimeout(() => {
        this.setState({ showCopiedFeedback: false });
      }, 1000);
    }
  }

  downloadPDF() {
    if (this.pdfMode === "html") {
      this.downloadPDF_HTML();
    } else if (this.pdfMode === "form") {
      this.downloadPDF_Form();
    }
  }

  downloadPDF_Form() {
    const {config, region} = this.props;
    const lib = window.pdfform();
    const url = `${this.baseUrl}/forms/58838-eu-master.pdf`;

    function fill(buf) {
      const fields = {};

      Object.keys(configMap).map((partKey) => {
        const attributes = configMap[partKey];
        return Object.keys(attributes).map((attrKey) => {
          const { hidden, assetType, regional, options } = configMap[partKey][
            attrKey
          ];

          if (hidden) {
            return null;
          }

          const selectedValue = config[partKey][attrKey];
          if (!selectedValue) {
            return null;
          }

          if (assetType === "material") {
            const selectedMaterial = materialsMap.MATERIALS[selectedValue];
            if (selectedMaterial) {
              return null;
            }
            return null;
          } else {
            const isRegionalOption = regional || false;
            const opts = isRegionalOption ? options[region] : options;
            const selectedOption = opts.find((el) => el.value === selectedValue);
            if (selectedOption.hidden) {
              return null;
            }
      
            if (selectedOption && selectedOption.hasOwnProperty("form")) {
              const key = selectedOption.form.key;
              const val = selectedOption.form.val;
              // console.log(selectedOption.form);
              
              if (val) {
                return fields[key] = [val];
              }

              const compoundVal = selectedOption.form.compound_val;
              if (compoundVal) {
                const relValue = config[compoundVal.part][compoundVal.attr];
                return fields[key] = [compoundVal.values[relValue]];
              }
            }

            return null;
          }
        });        
      });
      
      let filledPDF; // Uint8Array
      try {
        filledPDF = lib.transform(buf, fields);
      } catch (error) {
        console.error("Error filling PDF form", error);
      }

      const blob = new Blob([filledPDF], {type: 'application/pdf'});
      window.saveAs(blob, 'pdfform.js_generated.pdf');
    }

    const xhr = new XMLHttpRequest();
    xhr.open('GET', url, true);
    xhr.responseType = 'arraybuffer';

    xhr.onload = function() {
      if (this.status === 200) {
        return fill(this.response);
      }

      console.error("Error loading PDF form", url);
    };

    xhr.send();
  }

  downloadPDF_HTML() {
    const { region } = this.props;

    const A4 = [595.28, 841.89];
    const doc = new jsPDF({ format: A4, unit: "px" });

    const content = document.querySelector(".app-nitrum .scrollarea");
    const clone = content.cloneNode(true);
    clone.className = "nitrum-pdf";
    document.body.appendChild(clone);
    
    // Use html2canvas because jsPDF doesn't handle unicode characters correctly
    // And some languages look broken
    html2canvas(document.querySelector(".nitrum-pdf")).then(canvas => {
      const srcSize = clone.getBoundingClientRect();
      console.log("CANVAS", srcSize.width/2, srcSize.height/2);
      doc.addImage(canvas, 'PNG', 0, 0, srcSize.width/2, srcSize.height/2, null, "SLOW");
      doc.save(`your-nitrum-${region.toLowerCase()}.pdf`);
      clone.remove();
    });
  };

  render() {
    const { t, desktop, nitrumOpen, configCode } = this.props;
    const { showCopiedFeedback } = this.state;

    return (
      <div
        className={`app-nav-nitrum ${desktop ? "desktop" : ""} ${
          nitrumOpen ? "open" : ""
        }`}
      >
        <div className="share">
          <span>{t('share')}:</span>
          <a
            data-interact="share"
            data-item="facebook"
            className="btn btn-circle btn-link btn-facebook btn-share"
            href={this.getShareUrl("facebook")}
            target="_blank"
            rel="noopener noreferrer"
          >
            <IconFacebook />
          </a>
          <a
            data-interact="share"
            data-item="twitter"
            className="btn btn-circle btn-link btn-twitter btn-share"
            href={this.getShareUrl("twitter")}
            target="_blank"
            rel="noopener noreferrer"
          >
            <IconTwitter />
          </a>
          <a
            data-interact="share"
            data-item="email"
            className="btn btn-circle btn-link btn-email btn-share"
            href={this.getShareUrl("email")}
            target="_blank"
            rel="noopener noreferrer"
          >
            <IconEmail />
          </a>
        </div>
        <div className="nitrum-code">
          <div className="code">
            <input
              ref={this.copyInput}
              type="text"
              value={configCode}
              readOnly
            ></input>
            <div className={`feedback ${showCopiedFeedback ? 'show' : ''}`}>
              {t("copied_to_clipboard")}!
            </div>
            <button onClick={() => this.copyCode()}>
              <IconCopy />
            </button>
          </div>
          <div className="hint">{t("copy_code")}</div>
        </div>
        <div className="action-item action-item-desktop">
          <button
            data-interact="cta"
            data-item="download-pdf"
            className="btn btn-lg btn-primary btn-icon btn-icon-right"
            onClick={() => this.downloadPDF()}
          >
            {t("download_pdf")}
            <IconDownload className="icon icon-right" />
          </button>
        </div>
      </div>
    );
  }
}

export default withTranslation()(connect(mapState)(NavNitrum));
